export default __webpack_public_path__ + "static/media/promo-bundling.a9a324f0.png";